"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentValidationResultSchema = exports.ComponentValidationResultItemSchema = exports.ComponentValidationErrorType = void 0;
exports.isExpressionValidationResultItem = isExpressionValidationResultItem;
const zod_1 = require("zod");
const BoundaryLevel_1 = require("./BoundaryLevel");
var ComponentValidationErrorType;
(function (ComponentValidationErrorType) {
    ComponentValidationErrorType["ModelResolutionError"] = "ModelResolutionError";
    ComponentValidationErrorType["ModelValidationError"] = "ModelValidationError";
    ComponentValidationErrorType["UnmappedSignals"] = "UnmappedSignals";
    ComponentValidationErrorType["ModeValidationError"] = "ModeValidationError";
    ComponentValidationErrorType["BoundaryValidationError"] = "BoundaryValidationError";
    ComponentValidationErrorType["ResourceValidationError"] = "ResourceValidationError";
    ComponentValidationErrorType["FunctionValidationError"] = "FunctionValidationError";
    ComponentValidationErrorType["ModeCircularReferenceError"] = "ModeCircularReferenceError";
    ComponentValidationErrorType["ParameterValidationError"] = "ParameterValidationError";
    ComponentValidationErrorType["InternalConsistencyError"] = "InternalConsistencyError";
    ComponentValidationErrorType["SpiceTestRunError"] = "SpiceTestRunError";
    ComponentValidationErrorType["ExpressionValidationError"] = "ExpressionValidationError";
    ComponentValidationErrorType["GenericError"] = "GenericError";
})(ComponentValidationErrorType || (exports.ComponentValidationErrorType = ComponentValidationErrorType = {}));
exports.ComponentValidationResultItemSchema = zod_1.z
    .object({
    type: zod_1.z.nativeEnum(ComponentValidationErrorType),
    message: zod_1.z.string(),
    severity: BoundaryLevel_1.BoundaryLevelSchema,
    innerResult: zod_1.z.any().optional(),
})
    .catchall(zod_1.z.any());
exports.ComponentValidationResultSchema = zod_1.z.object({
    isValid: zod_1.z.boolean(),
    errors: exports.ComponentValidationResultItemSchema.array().optional(),
});
function isExpressionValidationResultItem(item) {
    return item?.type === ComponentValidationErrorType.ExpressionValidationError;
}
//# sourceMappingURL=ComponentValidationResult.js.map